/* MerchFlex client catalog: product switch, price ladder, live designers, catalog overlay and quote builder. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const parse = (el) => { try { return JSON.parse(el.textContent); } catch (e) { console.error('mf: bad catalog data', e); return null; } };
  const money = (n) => '$' + (Math.round(n * 100) % 100 ? n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : Math.round(n).toLocaleString('en-US'));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const uid = () => Math.random().toString(36).slice(2, 9);
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const plural = (n, p) => `${n} ${n === 1 ? p.one : p.many}`;

  /* ---------- Catalog data ---------- */

  const products = $$('script[data-mf-product-data]').map(parse).filter((d) => d && d.product && d.lines && d.lines.length);
  if (!products.length) return;
  const productById = {};
  const lineById = {};
  products.forEach((d) => {
    d.sizes = d.sizes || [];
    productById[d.product.id] = d;
    d.lines.forEach((l) => { l.productId = d.product.id; lineById[l.id] = l; });
  });
  const hoodieCfg = parse($('script[data-mf-hoodie-designer-data]') || { textContent: 'null' }) || { layouts: [], defaults: {} };
  const hatCfg = parse($('script[data-mf-hat-designer-data]') || { textContent: 'null' }) || { sidePrice: 0, sides: {} };
  const layouts = hoodieCfg.layouts || [];
  const inkButtons = $$('[data-mf-ink]');
  const inks = inkButtons.map((b) => ({ name: b.dataset.mfInk, hex: b.dataset.hex }));
  const patchButtons = $$('[data-mf-patch]');
  const patches = patchButtons.map((b) => ({ name: b.dataset.mfPatch, img: b.dataset.img, shape: b.dataset.shape }));

  // "Your normals": items already made for this customer, reordered at a set price.
  const normals = (parse($('script[data-mf-normals-data]') || { textContent: '[]' }) || []).filter((n) => n && n.id);
  const normalById = {};
  normals.forEach((n) => { n.sizes = n.sizes || []; n.price = Number(n.price) || 0; normalById[n.id] = n; });

  const colorOf = (line, name) => line.colors.find((c) => c.name === name) || line.colors[0] || {};
  const tierIndex = (tiers, count) => { let i = 0; tiers.forEach((t, k) => { if (count >= t.min) i = k; }); return i; };
  const isTierLine = (l) => l.pricing !== 'flat' && l.prices.length;

  /* ---------- State ---------- */

  const storeKey = 'mf-catalog:' + location.pathname;
  const firstOf = (pid) => (productById[pid] ? productById[pid].lines[0] : null);
  const hoodieLine = firstOf('hoodies');
  const hatLine = firstOf('hats');
  const defaults = {
    product: products[0].product.id,
    plan: {},
    ladderLine: {},
    hoodie: {
      lineId: hoodieLine && hoodieLine.id,
      color: hoodieLine && (hoodieLine.colors.find((c) => /army/i.test(c.name)) || hoodieLine.colors[0] || {}).name,
      layout: layouts[0] ? layouts[0].id : null,
      ink: (inks.find((i) => i.name === (hoodieCfg.defaults || {}).ink) || inks[0] || {}).name,
      city: '', store: '', bicep: 'flag', back: 'logo', backText: '',
    },
    hat: {
      lineId: hatLine && hatLine.id,
      color: hatLine && (hatLine.colors[0] || {}).name,
      patch: patches[0] ? patches[0].name : '',
      side: 'none', sideText: '',
    },
    items: [],
    normals: {},
    builderOpen: false,
    mode: 'branch',
  };
  let state = JSON.parse(JSON.stringify(defaults));
  try {
    const saved = JSON.parse(localStorage.getItem(storeKey) || 'null');
    if (saved && typeof saved === 'object') {
      state = { ...state, ...saved, hoodie: { ...state.hoodie, ...(saved.hoodie || {}) }, hat: { ...state.hat, ...(saved.hat || {}) } };
      // Earlier version kept hoodie designer fields at the top level.
      ['lineId', 'color', 'layout', 'ink', 'city', 'store', 'bicep'].forEach((k) => { if (saved[k] !== undefined && !saved.hoodie) state.hoodie[k] = saved[k]; });
    }
  } catch (e) { /* storage unavailable */ }
  if (!productById[state.product]) state.product = defaults.product;
  if (!lineById[state.hoodie.lineId]) state.hoodie.lineId = defaults.hoodie.lineId;
  if (!lineById[state.hat.lineId]) state.hat.lineId = defaults.hat.lineId;
  if (!layouts.find((l) => l.id === state.hoodie.layout)) state.hoodie.layout = defaults.hoodie.layout;
  if (!inks.find((i) => i.name === state.hoodie.ink)) state.hoodie.ink = defaults.hoodie.ink;
  if (!['logo', 'custom'].includes(state.hoodie.back)) state.hoodie.back = 'logo';
  state.hoodie.backText = String(state.hoodie.backText || '');
  if (!patches.find((p) => p.name === state.hat.patch)) state.hat.patch = defaults.hat.patch;
  state.plan = state.plan && typeof state.plan === 'object' ? state.plan : {};
  state.ladderLine = state.ladderLine && typeof state.ladderLine === 'object' ? state.ladderLine : {};
  state.items = (state.items || []).map((it) => ({ productId: (lineById[it.lineId] || {}).productId, ...it })).filter((it) => lineById[it.lineId]);
  delete state.hats;
  // Personal orders ("Just me") only exist where the template has the Order-for section.
  const modeEl = $('[data-mf-mode]');
  if (!modeEl || state.mode !== 'personal') state.mode = 'branch';
  const personal = () => state.mode === 'personal';
  state.normals = state.normals && typeof state.normals === 'object' ? state.normals : {};
  Object.keys(state.normals).forEach((k) => { if (!normalById[k]) delete state.normals[k]; });

  const save = () => { try { localStorage.setItem(storeKey, JSON.stringify(state)); } catch (e) { /* ignore */ } };

  /* ---------- Pricing ---------- */

  const qtyOf = (it) => (productById[it.productId].sizes.length
    ? productById[it.productId].sizes.reduce((s, z) => s + (Number((it.sizes || {})[z]) || 0), 0)
    : Number(it.qty) || 0);

  const normalQty = (n) => {
    const o = state.normals[n.id] || {};
    return n.sizes.length ? n.sizes.reduce((s, z) => s + (Number((o.sizes || {})[z]) || 0), 0) : Number(o.qty) || 0;
  };
  const activeNormals = () => (personal() ? [] : normals.filter((n) => normalQty(n) > 0));

  const rawCounts = () => {
    const c = {};
    products.forEach((d) => { c[d.product.id] = { all: 0, tier: 0 }; });
    state.items.forEach((it) => {
      const q = qtyOf(it);
      c[it.productId].all += q;
      if (isTierLine(lineById[it.lineId])) c[it.productId].tier += q;
    });
    return c;
  };
  // Tier count used for pricing, including any cross-product unlock (hoodies unlocking hat pricing).
  const pricingCount = (pid, counts) => {
    const d = productById[pid];
    const own = counts[pid].tier;
    const b = d.product.boostFrom;
    if (b && counts[b] && counts[b].tier >= (d.product.boostMin || Infinity)) return { count: Math.max(own, counts[b].tier), boosted: counts[b].tier > own };
    return { count: own, boosted: false };
  };
  // Personal orders: the checkout product variant matching size, camo/solid, style and hat side detail.
  const variantFor = (it, size) => {
    const line = lineById[it.lineId];
    if (!line.checkout) return null;
    const c = colorOf(line, it.color);
    const side = it.side && it.side !== 'none' && (hatCfg.sides || {})[it.side] ? hatCfg.sides[it.side].label : 'None';
    const want = new Set([size || productById[it.productId].sizes[0], c.camo ? 'Camo' : 'Solid', it.style, side].filter(Boolean).map((v) => String(v).toLowerCase()));
    return line.checkout.variants.find((v) => v.options.every((o) => o === 'Default Title' || want.has(String(o).toLowerCase()))) || null;
  };
  const personalUnit = (it) => { const v = variantFor(it); return v ? v.price / 100 : null; };

  const unitPrice = (it, counts) => {
    if (personal()) return personalUnit(it) || 0;
    const line = lineById[it.lineId];
    if (line.pricing === 'flat') {
      const s = line.styles.find((x) => x.name === it.style) || line.styles[0];
      return s ? s.price : 0;
    }
    const d = productById[it.productId];
    const c = colorOf(line, it.color);
    const list = c.camo && line.camoPrices.length ? line.camoPrices : line.prices;
    const n = pricingCount(it.productId, counts).count;
    let p = list[Math.min(tierIndex(d.tiers, n), list.length - 1)] || 0;
    if (it.side && it.side !== 'none') p += Number(hatCfg.sidePrice) || 0;
    return p;
  };
  const totals = () => {
    const counts = rawCounts();
    let total = 0;
    state.items.forEach((it) => { total += qtyOf(it) * unitPrice(it, counts); });
    let reorders = 0;
    activeNormals().forEach((n) => { const q = normalQty(n); reorders += q; total += q * n.price; });
    const all = Object.values(counts).reduce((s, c) => s + c.all, 0) + reorders;
    return { counts, total, all, reorders };
  };

  /* ---------- Marker loops ---------- */

  const observeLoops = (root = document) => {
    const loops = $$('[data-mf-loop]:not(.is-drawn)', root);
    if (!('IntersectionObserver' in window)) { loops.forEach((l) => l.classList.add('is-drawn')); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-drawn'); io.unobserve(e.target); }
    }), { threshold: 0.6 });
    loops.forEach((l) => io.observe(l));
  };
  observeLoops();

  /* ---------- Product switch ---------- */

  const switchBar = $('[data-mf-switch]');
  if (switchBar) {
    const setH = () => document.documentElement.style.setProperty('--mf-switch-h', switchBar.offsetHeight + 'px');
    setH();
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(switchBar);
  }
  const tabsEl = $('[data-mf-product-tabs]');
  const sectionOf = (el) => el.closest('.shopify-section') || el;
  const designers = $$('[data-mf-designer-for]');

  const renderTabs = () => {
    if (!tabsEl) return;
    if (products.length < 2) { tabsEl.hidden = true; return; }
    tabsEl.innerHTML = products.map((d) => `<button type="button" role="tab" class="mf-tab" aria-selected="${d.product.id === state.product}" data-product="${esc(d.product.id)}">${esc(d.product.label)}</button>`).join('');
  };
  const setProduct = (pid, { scroll } = {}) => {
    if (!productById[pid]) return;
    state.product = pid;
    renderTabs();
    designers.forEach((el) => {
      const on = el.dataset.mfDesignerFor === pid;
      el.hidden = !on;
      const sec = sectionOf(el);
      if (sec !== el) sec.hidden = !on;
    });
    renderLadderChips(); renderLadder(); renderPicker();
    if (pid === 'hoodies') renderHoodie(); else renderHat();
    save();
    if (scroll) {
      openBuilder();
      const d = designers.find((el) => el.dataset.mfDesignerFor === pid);
      if (d) d.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth' });
    }
  };
  // Photo cards for the other products, between the estimate and the designer.
  const picker = $('[data-mf-picker]');
  function renderPicker() {
    if (!picker) return;
    const others = products.filter((d) => d.product.id !== state.product);
    sectionOf(picker).hidden = !others.length;
    picker.innerHTML = others.map((d) => `<button type="button" class="mf-pick" data-product="${esc(d.product.id)}">
        <span class="mf-pick__img">${d.product.image ? `<img src="${esc(d.product.image)}" alt="" width="240" height="240" loading="lazy">` : ''}</span>
        <span class="mf-pick__label">${esc(d.product.label)}</span>
      </button>`).join('');
  }
  if (picker) picker.addEventListener('click', (e) => {
    const b = e.target.closest('[data-product]');
    if (!b) return;
    const before = picker.getBoundingClientRect().top;
    setProduct(b.dataset.product);
    window.scrollBy(0, picker.getBoundingClientRect().top - before);
    const first = $('.mf-pick', picker);
    if (first) first.focus({ preventScroll: true });
  });
  if (tabsEl) tabsEl.addEventListener('click', (e) => {
    const b = e.target.closest('[data-product]');
    if (b && b.dataset.product !== state.product) setProduct(b.dataset.product);
  });

  /* ---------- Price ladder ---------- */

  const ladder = $('[data-mf-ladder]');
  const ladderQty = $('[data-mf-ladder-qty]');
  const ladderTrack = $('[data-mf-ladder-track]');
  const ladderLinesEl = $('[data-mf-ladder-lines]');
  const defaultPlan = Number(ladderQty && ladderQty.value) || 30;

  const priceKey = (l) => l.prices.join(',') + '|' + l.camoPrices.join(',');
  const ladderLines = (d) => {
    const seen = new Set();
    return d.lines.filter((l) => isTierLine(l) && !seen.has(priceKey(l)) && seen.add(priceKey(l)));
  };

  function renderLadderChips() {
    if (!ladderLinesEl) return;
    const d = productById[state.product];
    const ls = ladderLines(d);
    if (!ls.find((l) => l.id === state.ladderLine[d.product.id])) state.ladderLine[d.product.id] = ls[0] && ls[0].id;
    ladderLinesEl.hidden = ls.length < 2;
    ladderLinesEl.innerHTML = ls.length < 2 ? '' : ls.map((l) =>
      `<button type="button" class="mf-chip" role="radio" aria-checked="${l.id === state.ladderLine[d.product.id]}" data-id="${l.id}">${esc(l.short)}</button>`).join('');
  }

  function renderLadder() {
    if (!ladder || !ladderTrack) return;
    const d = productById[state.product];
    const p = d.product;
    const line = lineById[state.ladderLine[p.id]] || ladderLines(d)[0];
    if (!line) return;
    const counts = rawCounts();
    const pc = pricingCount(p.id, counts);
    const linked = counts[p.id].tier > 0;
    const qty = linked ? counts[p.id].tier : Math.max(1, Number(state.plan[p.id] || defaultPlan));
    const priceQty = linked ? pc.count : qty;
    const idx = tierIndex(d.tiers, priceQty);
    const showName = ladderLines(d).length > 1;

    const sub = $('[data-mf-ladder-sub]');
    if (sub) {
      let t = p.ladderSub || '';
      if (pc.boosted) t += ` Your ${plural(counts[p.boostFrom].tier, productById[p.boostFrom].product)} unlock ${d.tiers[idx].label} pricing on ${p.many}.`;
      sub.textContent = t;
    }
    const qtyLabel = $('[data-mf-ladder-qty-label]');
    if (qtyLabel) qtyLabel.textContent = `${p.label} in your order`;
    if (ladderQty && document.activeElement !== ladderQty) ladderQty.value = qty;
    const linkedEl = $('[data-mf-ladder-linked]');
    if (linkedEl) linkedEl.hidden = !linked;

    ladderTrack.style.setProperty('--n', d.tiers.length);
    ladderTrack.style.setProperty('--i', idx);
    if (ladderTrack.dataset.product !== p.id) {
      ladderTrack.innerHTML = '<span class="mf-ladder__fill" aria-hidden="true"></span><span class="mf-ladder__marker" aria-hidden="true"></span>' +
        d.tiers.map((t, i) => `<li class="mf-ladder__stop" data-i="${i}">
          <span class="mf-ladder__range">${esc(t.label)}</span>
          <span class="mf-ladder__dot" aria-hidden="true"></span>
          <span class="mf-ladder__name"></span>
          <span class="mf-ladder__price"></span>
          <span class="mf-ladder__camo"></span>
        </li>`).join('');
      ladderTrack.dataset.product = p.id;
    }
    $$('.mf-ladder__stop', ladderTrack).forEach((li, i) => {
      li.classList.toggle('is-active', i === idx);
      li.setAttribute('aria-current', i === idx ? 'true' : 'false');
      $('.mf-ladder__name', li).textContent = showName ? line.short : '';
      $('.mf-ladder__price', li).textContent = money(line.prices[i] || 0);
      const camo = line.camoPrices[i];
      $('.mf-ladder__camo', li).textContent = camo ? `Camo ${money(camo)}` : '';
    });

    const price = line.prices[idx] || 0;
    const top = line.prices[0] || price;
    $('[data-mf-ladder-total]').textContent = money(qty * price);
    $('[data-mf-ladder-math]').textContent = `${plural(qty, p)} × ${money(price)} each${showName ? ` · ${line.short}` : ''}${line.camoPrices.length ? ' (non-camo)' : ''}`;
    const saveEl = $('[data-mf-ladder-save]');
    const saved = (top - price) * qty;
    saveEl.innerHTML = saved > 0 ? `<strong>${money(saved)}</strong><span>saved vs. ${esc(d.tiers[0].label)} pricing</span>` : '';
    saveEl.hidden = saved <= 0;
    const next = d.tiers[idx + 1];
    $('[data-mf-ladder-next]').textContent = next
      ? `Add ${next.min - priceQty} more to drop to ${money(line.prices[idx + 1] || price)} each.`
      : 'Best price reached.';
    $$('[data-mf-price-table]').forEach((table) => {
      const pid = table.dataset.mfPriceTable === 'hats' ? 'hats' : 'hoodies';
      if (!productById[pid]) return;
      const n = pid === p.id ? priceQty : Math.max(1, pricingCount(pid, counts).count || Number(state.plan[pid] || defaultPlan));
      const ti = tierIndex(productById[pid].tiers, n);
      $$('[data-tier]', table).forEach((cell) => cell.classList.toggle('is-active', Number(cell.dataset.tier) === ti));
    });
  }

  if (ladderLinesEl) ladderLinesEl.addEventListener('click', (e) => {
    const b = e.target.closest('[data-id]');
    if (!b) return;
    state.ladderLine[state.product] = b.dataset.id;
    renderLadderChips(); renderLadder(); save();
  });
  if (ladderQty) {
    const setPlan = (v) => {
      if (rawCounts()[state.product].tier > 0) return; // quantity follows the order once items are added
      state.plan[state.product] = Math.min(999, Math.max(1, Math.round(Number(v) || 1)));
      renderLadder(); save();
    };
    ladderQty.addEventListener('input', () => setPlan(ladderQty.value));
    ladderQty.addEventListener('blur', () => renderLadder());
    $$('[data-mf-step]').forEach((b) => b.addEventListener('click', () => {
      if (rawCounts()[state.product].tier > 0) { document.getElementById('mf-quote').scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth' }); return; }
      setPlan((Number(state.plan[state.product] || defaultPlan)) + Number(b.dataset.mfStep));
    }));
  }

  /* ---------- Shared designer helpers ---------- */

  const radioKeys = (root) => root.addEventListener('keydown', (e) => {
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
    const group = e.target.closest('[role="radiogroup"]');
    if (!group) return;
    const radios = $$('[role="radio"]:not([disabled])', group);
    const i = radios.indexOf(e.target);
    if (i < 0) return;
    e.preventDefault();
    const next = radios[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + radios.length) % radios.length];
    next.focus(); next.click();
  });

  const addToQuote = (root, item, label) => {
    const existing = state.items.find((x) => x.lineId === item.lineId && x.color === item.color && (x.patch || '') === (item.patch || '') && (x.side || 'none') === (item.side || 'none'));
    const target = existing || item;
    if (!existing) state.items.push(item);
    save(); renderQuote();
    const status = $('[data-mf-add-status]', root);
    if (status) {
      status.textContent = existing ? `${label} is already in your quote.` : `Added ${label}. Set the quantity below.`;
      status.classList.add('is-ok');
    }
    const row = document.querySelector(`[data-item="${target.id}"]`);
    if (row) {
      row.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
      const first = $('input[type="number"]', row);
      setTimeout(() => first && first.focus({ preventScroll: true }), 450);
    }
  };

  const colorButtons = (line, selected, photo) => {
    let html = ''; let lastCamo = false;
    line.colors.forEach((c, i) => {
      if (!photo && i && c.camo && !lastCamo) html += '<span class="mf-colorgrid__sep" aria-hidden="true"></span>';
      lastCamo = c.camo;
      html += photo
        ? `<button type="button" class="mf-colorbtn mf-colorbtn--photo" role="radio" aria-checked="${c.name === selected}" aria-label="${esc(c.name)}" title="${esc(c.name)}" data-color="${esc(c.name)}"><img src="${esc(c.thumb)}" alt="" loading="lazy" width="128" height="90"></button>`
        : `<button type="button" class="mf-colorbtn" role="radio" aria-checked="${c.name === selected}" aria-label="${esc(c.name)}" title="${esc(c.name)}" data-color="${esc(c.name)}" style="--sw:${esc(c.hex)};${c.pattern ? `--sw-img:url('${esc(c.pattern)}')` : ''}"></button>`;
    });
    return html;
  };

  /* ---------- Hoodie designer ---------- */

  const hd = $('[data-mf-designer-for="hoodies"]');
  const hs = state.hoodie;
  const stage = hd && $('[data-mf-stage]', hd);
  const cityDefault = ((hoodieCfg.defaults || {}).city || 'YOUR CITY').toUpperCase();
  const zoneMeta = {
    'chest-full': { x: 30.5, y: 40, label: 'Chest logo' },
    'chest-left': { x: 71.5, y: 32, label: 'Left-chest logo' },
    city: { x: 11.5, y: 52, label: 'Your city' },
    'bicep-left': { x: 85.5, y: 39, label: 'Flag + store #' },
    'bicep-right': { x: 14.5, y: 39, label: 'Flag or store #' },
    back: { x: 27.5, y: 34, label: 'Full back print' },
  };
  // Same order as the layout location lists: chest, sleeve, left bicep, back, right bicep.
  const zoneOrder = ['chest-full', 'chest-left', 'city', 'bicep-left', 'back', 'bicep-right'];
  const activeLayout = () => layouts.find((l) => l.id === hs.layout) || layouts[0];
  const zonesFor = (line) => {
    if (line.decoration === 'embroidery') return { 'chest-left': 'emb' };
    const lay = activeLayout();
    if (!lay) return { 'chest-full': 'print' };
    const z = {};
    if (lay.chest === 'full') z['chest-full'] = 'print';
    if (lay.chest === 'left-print') z['chest-left'] = 'print';
    if (lay.chest === 'left-emb') z['chest-left'] = 'emb';
    if (lay.city) z.city = 'print';
    if (lay.bicepLeft) z['bicep-left'] = 'print';
    if (lay.bicepRight) z['bicep-right'] = 'print';
    if (lay.back) z.back = 'print';
    return z;
  };

  let lastCallouts = [];
  const renderCallouts = (list) => {
    lastCallouts = list;
    if (!stage || hd.hidden) return;
    let layer = $('.mf-callouts', stage);
    if (!layer) {
      layer = document.createElement('div');
      layer.className = 'mf-callouts';
      layer.setAttribute('aria-hidden', 'true');
      stage.appendChild(layer);
    }
    const frame = $('.mf-stage__frame', stage);
    const sr = stage.getBoundingClientRect();
    const fr = frame.getBoundingClientRect();
    if (!fr.width || getComputedStyle(layer).display === 'none') { layer.innerHTML = ''; return; }
    const fx = fr.left - sr.left; const fy = fr.top - sr.top;
    const pts = list.map((c) => {
      const m = zoneMeta[c.z];
      return { ...c, px: fx + (m.x / 100) * fr.width, py: fy + (m.y / 100) * fr.height, left: m.x <= 50 };
    });
    ['left', 'right'].forEach((side) => {
      const group = pts.filter((p) => (side === 'left') === p.left).sort((a, b) => a.py - b.py);
      let prev = -Infinity;
      group.forEach((p) => { p.ly = Math.max(p.py - 18, prev + 52); prev = p.ly; });
    });
    const edgeL = fx - 10; const edgeR = fx + fr.width + 10;
    let svg = '<svg xmlns="http://www.w3.org/2000/svg">';
    let html = '';
    pts.forEach((p) => {
      const ex = p.left ? edgeL : edgeR;
      svg += `<line x1="${ex}" y1="${p.ly}" x2="${p.px}" y2="${p.py}"/><circle cx="${p.px}" cy="${p.py}" r="5"/>`;
      html += p.left
        ? `<span class="mf-callout mf-callout--l" style="right:${sr.width - ex + 6}px;top:${p.ly}px"><b>${p.n}</b><span>${esc(p.label)}</span></span>`
        : `<span class="mf-callout" style="left:${ex + 6}px;top:${p.ly}px;--mf-callout-max:${Math.max(60, sr.width - ex - 44)}px"><b>${p.n}</b><span>${esc(p.label)}</span></span>`;
    });
    layer.innerHTML = svg + '</svg>' + html;
  };
  if (stage && 'ResizeObserver' in window) new ResizeObserver(() => renderCallouts(lastCallouts)).observe(stage);

  const setView = (v) => {
    if (!stage) return;
    stage.dataset.view = v;
    $$('[data-mf-view]', hd).forEach((b) => {
      const on = b.dataset.mfView === v;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on);
    });
  };

  const renderHoodieStage = () => {
    if (!stage) return;
    const line = lineById[hs.lineId];
    const color = colorOf(line, hs.color);
    const ink = inks.find((i) => i.name === hs.ink) || { hex: '#fff', name: '' };
    stage.style.setProperty('--mf-garment', color.hex || '#888');
    stage.style.setProperty('--mf-pattern', color.pattern ? `url('${color.pattern}')` : 'none');
    stage.style.setProperty('--mf-ink', ink.hex);
    const zones = zonesFor(line);
    $$('[data-zone]', stage).forEach((el) => {
      const z = el.dataset.zone;
      el.classList.toggle('is-on', !!zones[z]);
      el.classList.toggle('is-emb', zones[z] === 'emb');
    });
    const city = (hs.city || cityDefault).toUpperCase();
    const store = hs.store || '123';
    $('[data-mf-city-out]', stage).textContent = city;
    stage.style.setProperty('--mf-city-size', Math.min(5.4, 44 / (Math.max(6, city.length) * 0.68)).toFixed(2) + 'cqw');
    $('[data-mf-store-out]', stage).textContent = store;
    $('[data-mf-bicep-num]', stage).textContent = store;
    $('[data-mf-bicep-num]', stage).hidden = hs.bicep !== 'store';
    $('[data-mf-bicep-flag]', stage).hidden = hs.bicep === 'store';
    $('[data-zone="back"]', stage).classList.toggle('is-custom', hs.back === 'custom');
    if (stage.dataset.view === 'back' && !zones.back) setView('front');
    const backBtn = $('[data-mf-view="back"]', hd);
    if (backBtn) backBtn.disabled = !zones.back;

    const view = stage.dataset.view;
    const ordered = zoneOrder.filter((z) => zones[z]);
    const visible = ordered.filter((z) => (view === 'back' ? z === 'back' : z !== 'back'));
    const labelFor = (z) => {
      if (zones[z] === 'emb') return 'Embroidered logo';
      if (z === 'back' && hs.back === 'custom') return 'Custom back design';
      if (z === 'bicep-right') return hs.bicep === 'store' ? 'Store # on bicep' : 'Flag on bicep';
      return zoneMeta[z].label;
    };
    const legend = $('[data-mf-legend]', hd);
    if (legend) legend.innerHTML = ordered.map((z, i) => `<li><b>${i + 1}</b>${esc(labelFor(z))}</li>`).join('');
    renderCallouts(visible.map((z) => ({ z, n: ordered.indexOf(z) + 1, label: labelFor(z) })));
    const cn = $('[data-mf-color-name]', hd); if (cn) cn.textContent = color.name || '';
    const inn = $('[data-mf-ink-name]', hd); if (inn) inn.textContent = ink.name;
  };

  const renderHoodieControls = () => {
    const line = lineById[hs.lineId];
    const emb = line.decoration === 'embroidery';
    const lay = activeLayout();
    $$('[data-mf-layout]', hd).forEach((b) => {
      const on = b.dataset.mfLayout === hs.layout;
      b.classList.toggle('is-active', on && !emb);
      b.setAttribute('aria-checked', on && !emb);
      b.disabled = emb;
    });
    const lc = $('[data-mf-layout-control]', hd); if (lc) lc.hidden = emb;
    const en = $('[data-mf-emb-note]', hd); if (en) en.hidden = !emb;
    const il = $('[data-mf-ink-label]', hd); if (il) il.textContent = emb ? 'Thread color' : 'Print color';
    const detail = $('[data-mf-layout-detail]', hd);
    if (detail) {
      detail.innerHTML = emb || !lay ? '' : lay.lines.filter((t) => t && t.trim()).map((t, i) => `<li><b>${i + 1}</b>${esc(t.trim())}</li>`).join('');
      detail.hidden = emb;
    }
    const zones = zonesFor(line);
    const cf = $('[data-mf-city-field]', hd); if (cf) cf.hidden = !zones.city;
    const sf = $('[data-mf-store-field]', hd); if (sf) sf.hidden = !(zones['bicep-left'] || (zones['bicep-right'] && hs.bicep === 'store'));
    const bc = $('[data-mf-bicep-choice]', hd); if (bc) bc.hidden = !zones['bicep-right'];
    $$('[data-mf-bicep]', hd).forEach((b) => { const on = b.dataset.mfBicep === hs.bicep; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on); });
    const bkc = $('[data-mf-back-choice]', hd); if (bkc) bkc.hidden = !zones.back;
    const bkf = $('[data-mf-back-field]', hd); if (bkf) bkf.hidden = !zones.back || hs.back !== 'custom';
    $$('[data-mf-back]', hd).forEach((b) => { const on = b.dataset.mfBack === hs.back; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on); });
    const bkt = $('[data-mf-back-text]', hd); if (bkt && document.activeElement !== bkt) bkt.value = hs.backText;
    inkButtons.forEach((b) => b.setAttribute('aria-checked', b.dataset.mfInk === hs.ink));
    const ci = $('[data-mf-city]', hd); if (ci && document.activeElement !== ci) ci.value = hs.city;
    const si = $('[data-mf-store]', hd); if (si && document.activeElement !== si) si.value = hs.store;
  };

  function renderHoodie() {
    if (!hd || !hs.lineId) return;
    const line = lineById[hs.lineId];
    if (!line.colors.find((c) => c.name === hs.color)) hs.color = (line.colors[0] || {}).name;
    const chips = $('[data-mf-line-chips]', hd);
    if (chips) chips.innerHTML = productById.hoodies.lines.map((l) => `<button type="button" class="mf-chip" role="radio" aria-checked="${l.id === hs.lineId}" data-id="${l.id}">${esc(l.short)}</button>`).join('');
    const grid = $('[data-mf-color-grid]', hd);
    if (grid) grid.innerHTML = colorButtons(line, hs.color, false);
    renderHoodieControls(); renderHoodieStage(); renderDesignCard();
  }

  if (hd) {
    $('[data-mf-line-chips]', hd).addEventListener('click', (e) => {
      const b = e.target.closest('[data-id]'); if (!b) return;
      hs.lineId = b.dataset.id; renderHoodie(); save();
    });
    $('[data-mf-color-grid]', hd).addEventListener('click', (e) => {
      const b = e.target.closest('[data-color]'); if (!b) return;
      hs.color = b.dataset.color;
      $$('[data-color]', hd).forEach((x) => x.setAttribute('aria-checked', x === b));
      renderHoodieStage(); renderDesignCard(); save();
    });
    $$('[data-mf-layout]', hd).forEach((b) => b.addEventListener('click', () => {
      hs.layout = b.dataset.mfLayout;
      const lay = activeLayout();
      setView(lay && lay.back ? 'back' : 'front');
      renderHoodieControls(); renderHoodieStage(); renderDesignCard(); save();
    }));
    inkButtons.forEach((b) => b.addEventListener('click', () => { hs.ink = b.dataset.mfInk; renderHoodieControls(); renderHoodieStage(); renderDesignCard(); save(); }));
    $$('[data-mf-bicep]', hd).forEach((b) => b.addEventListener('click', () => { hs.bicep = b.dataset.mfBicep; renderHoodieControls(); renderHoodieStage(); renderDesignCard(); save(); }));
    $$('[data-mf-back]', hd).forEach((b) => b.addEventListener('click', () => {
      hs.back = b.dataset.mfBack; setView('back');
      renderHoodieControls(); renderHoodieStage(); renderDesignCard(); save();
      const bkt = $('[data-mf-back-text]', hd); if (hs.back === 'custom' && bkt && !hs.backText) bkt.focus();
    }));
    const bkt = $('[data-mf-back-text]', hd);
    bkt && bkt.addEventListener('input', () => { hs.backText = bkt.value.slice(0, 200); renderDesignCard(); save(); });
    $$('[data-mf-view]', hd).forEach((b) => b.addEventListener('click', () => { setView(b.dataset.mfView); renderHoodieStage(); }));
    const ci = $('[data-mf-city]', hd);
    ci && ci.addEventListener('input', () => { hs.city = ci.value.replace(/[^\p{L}\p{N} .'&-]/gu, '').slice(0, 14); renderHoodieStage(); renderDesignCard(); save(); });
    const si = $('[data-mf-store]', hd);
    si && si.addEventListener('input', () => { hs.store = si.value.replace(/[^0-9A-Za-z#-]/g, '').slice(0, 5); renderHoodieStage(); renderDesignCard(); save(); });
    radioKeys(hd);
    $('[data-mf-add]', hd).addEventListener('click', () => {
      const line = lineById[hs.lineId];
      addToQuote(hd, { id: uid(), productId: 'hoodies', lineId: line.id, color: hs.color, style: line.styles[0] ? line.styles[0].name : '', sizes: {} }, `${line.short} in ${hs.color}`);
    });
  }

  /* ---------- Hat designer ---------- */

  const td = $('[data-mf-designer-for="hats"]');
  const ts = state.hat;
  const hatPhoto = td && $('[data-mf-hat-photo]', td);
  const hatPatch = td && $('[data-mf-hat-patch]', td);

  const renderHatStage = () => {
    if (!td) return;
    const line = lineById[ts.lineId];
    const c = colorOf(line, ts.color);
    const patch = patches.find((p) => p.name === ts.patch) || patches[0];
    if (hatPhoto.getAttribute('src') !== c.img) { hatPhoto.src = c.img; hatPhoto.alt = `${line.name} in ${c.name}`; }
    const frame = hatPhoto.parentNode;
    frame.classList.toggle('is-angle', !!c.angle);
    frame.style.setProperty('--px', (line.patch || {}).x || 50);
    frame.style.setProperty('--py', (line.patch || {}).y || 47);
    frame.style.setProperty('--pw', (line.patch || {}).w || 45);
    if (patch) {
      hatPatch.hidden = false;
      if (hatPatch.getAttribute('src') !== patch.img) hatPatch.src = patch.img;
      hatPatch.alt = `${patch.name} patch`;
    } else hatPatch.hidden = true;
    const inset = $('[data-mf-side-inset]', td);
    const side = (hatCfg.sides || {})[ts.side];
    if (inset) {
      inset.hidden = !side;
      if (side) {
        const img = $('img', inset);
        if (img.getAttribute('src') !== side.img) img.src = side.img;
        img.alt = `${side.label} example`;
        $('figcaption', inset).innerHTML = `<strong>${esc(side.label)}</strong>${ts.sideText ? ` · ${esc(ts.sideText)}` : ''}<br><span>Real example · +${money(hatCfg.sidePrice || 0)} per hat</span>`;
      }
    }
    const cn = $('[data-mf-color-name]', td); if (cn) cn.textContent = c.name || '';
    const pn = $('[data-mf-patch-name]', td); if (pn) pn.textContent = patch ? patch.name : '';
    const spec = $('[data-mf-style-spec]', td); if (spec) spec.textContent = line.weight || '';
  };

  function renderHat() {
    if (!td || !ts.lineId) return;
    const line = lineById[ts.lineId];
    if (!line.colors.find((c) => c.name === ts.color)) ts.color = (line.colors[0] || {}).name;
    const chips = $('[data-mf-line-chips]', td);
    if (chips) chips.innerHTML = productById.hats.lines.map((l) => `<button type="button" class="mf-chip" role="radio" aria-checked="${l.id === ts.lineId}" data-id="${l.id}">${esc(l.short)}</button>`).join('');
    const grid = $('[data-mf-color-grid]', td);
    if (grid) grid.innerHTML = colorButtons(line, ts.color, true);
    patchButtons.forEach((b) => { const on = b.dataset.mfPatch === ts.patch; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on); });
    $$('[data-mf-side]', td).forEach((b) => { const on = b.dataset.mfSide === ts.side; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on); });
    const sf = $('[data-mf-side-field]', td); if (sf) sf.hidden = ts.side === 'none';
    const st = $('[data-mf-side-text]', td); if (st && document.activeElement !== st) st.value = ts.sideText;
    renderHatStage();
  }

  if (td) {
    $('[data-mf-line-chips]', td).addEventListener('click', (e) => {
      const b = e.target.closest('[data-id]'); if (!b) return;
      ts.lineId = b.dataset.id; renderHat(); save();
    });
    $('[data-mf-color-grid]', td).addEventListener('click', (e) => {
      const b = e.target.closest('[data-color]'); if (!b) return;
      ts.color = b.dataset.color;
      $$('[data-color]', td).forEach((x) => x.setAttribute('aria-checked', x === b));
      renderHatStage(); save();
    });
    patchButtons.forEach((b) => b.addEventListener('click', () => { ts.patch = b.dataset.mfPatch; renderHat(); save(); }));
    $$('[data-mf-side]', td).forEach((b) => b.addEventListener('click', () => { ts.side = b.dataset.mfSide; renderHat(); save(); }));
    const st = $('[data-mf-side-text]', td);
    st && st.addEventListener('input', () => { ts.sideText = st.value.slice(0, 20); renderHatStage(); save(); });
    radioKeys(td);
    $('[data-mf-add]', td).addEventListener('click', () => {
      const line = lineById[ts.lineId];
      addToQuote(td, { id: uid(), productId: 'hats', lineId: line.id, color: ts.color, patch: ts.patch, side: ts.side, sideText: ts.sideText, qty: 0 }, `${line.short} in ${ts.color}`);
    });
  }

  /* ---------- Catalog overlay ---------- */

  const dialog = $('[data-mf-catalog]');
  const catBody = dialog && $('[data-mf-catalog-body]', dialog);
  if (dialog && catBody) {
    const parts = $$('[data-mf-catalog-part]');
    parts.forEach((p) => catBody.appendChild(sectionOf(p)));
    const nav = $('[data-mf-catalog-nav]', dialog);
    if (nav) nav.innerHTML = parts.map((p) => `<a href="#${esc(p.id || '')}" data-target="${esc(p.id || '')}">${esc(p.dataset.mfCatalogLabel || '')}</a>`).join('');
    nav && nav.addEventListener('click', (e) => {
      const a = e.target.closest('[data-target]'); if (!a) return;
      e.preventDefault();
      const t = document.getElementById(a.dataset.target);
      if (t) t.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth' });
    });
    let opener = null;
    const open = () => {
      opener = document.activeElement;
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      document.documentElement.classList.add('mf-lock');
      observeLoops(dialog);
      catBody.focus({ preventScroll: true });
    };
    const close = () => {
      if (dialog.open && typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
    };
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('mf-lock');
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    });
    $$('[data-mf-catalog-open]').forEach((b) => b.addEventListener('click', open));
    $('[data-mf-catalog-close]', dialog).addEventListener('click', close);
    dialog.addEventListener('click', (e) => { if (e.target === dialog) close(); });
    window.mfCloseCatalog = close;
  }

  // Swatches and "Preview this" buttons (in the catalog) jump to the right designer.
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('[data-mf-pick]');
    const pv = e.target.closest('[data-mf-design]');
    if (!sw && !pv) return;
    const lineId = sw ? sw.dataset.line : pv.dataset.mfDesign;
    const line = lineById[lineId];
    if (!line) return;
    const ds = line.productId === 'hats' ? ts : hs;
    if (ds.lineId !== lineId) { ds.lineId = lineId; ds.color = null; }
    if (sw) ds.color = sw.dataset.color;
    if (window.mfCloseCatalog) window.mfCloseCatalog();
    setProduct(line.productId, { scroll: true });
  });

  /* ---------- Your normals ---------- */

  const normalsEl = $('[data-mf-normals]');
  const builderParts = [switchBar, ladder, picker].concat(designers).filter(Boolean).map(sectionOf);
  const builderClosed = () => builderParts.some((el) => el.classList.contains('mf-is-collapsed'));
  function openBuilder() {
    if (!builderClosed()) return;
    state.builderOpen = true; save();
    builderParts.forEach((el) => el.classList.remove('mf-is-collapsed'));
    if (switchBar) document.documentElement.style.setProperty('--mf-switch-h', switchBar.offsetHeight + 'px');
    setProduct(state.product);
  }
  if (normalsEl && normalsEl.dataset.collapse === 'true' && !state.builderOpen && !state.items.length) {
    builderParts.forEach((el) => el.classList.add('mf-is-collapsed'));
  }
  // Links into the builder (hero button, "Build something new", empty quote) open it first.
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href="#mf-products"], a[href="#mf-designer"]');
    if (!a || !builderClosed()) return;
    e.preventDefault();
    openBuilder();
    const t = switchBar ? sectionOf(switchBar) : designers[0];
    if (t) t.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth' });
    const first = $('[data-mf-product-tabs] [aria-selected="true"]') || $('[data-mf-line-chips] [role="radio"]');
    if (first) setTimeout(() => first.focus({ preventScroll: true }), 450);
  });

  const setNormalQty = (id, input) => {
    const o = state.normals[id] || (state.normals[id] = {});
    const v = Math.max(0, Math.min(999, Math.round(Number(input.value) || 0)));
    if (input.dataset.size) { o.sizes = o.sizes || {}; o.sizes[input.dataset.size] = v; } else o.qty = v;
  };
  const normalFoot = (n) => {
    const q = normalQty(n);
    return {
      qty: q ? `${q} × ${n.price ? money(n.price) : 'priced on your quote'}` : 'Not in this order',
      total: q && n.price ? money(q * n.price) : '',
    };
  };
  function renderNormalCards() {
    if (!normalsEl) return;
    normals.forEach((n) => {
      const card = $(`[data-mf-normal="${n.id}"]`, normalsEl);
      if (!card) return;
      const o = state.normals[n.id] || {};
      $$('input[type="number"]', card).forEach((inp) => {
        if (inp === document.activeElement) return;
        const v = inp.dataset.size ? Number((o.sizes || {})[inp.dataset.size]) : Number(o.qty);
        inp.value = v || '';
      });
      const f = normalFoot(n);
      $('[data-normal-qty]', card).textContent = f.qty;
      $('[data-normal-total]', card).textContent = f.total;
      card.classList.toggle('is-picked', normalQty(n) > 0);
    });
  }
  normalsEl && normalsEl.addEventListener('input', (e) => {
    const card = e.target.closest('[data-mf-normal]');
    if (!card || e.target.type !== 'number') return;
    setNormalQty(card.dataset.mfNormal, e.target);
    save(); renderQuote(); renderNormalCards();
  });

  /* ---------- Order for: branch quote or personal checkout ---------- */

  [ladder, normalsEl].filter(Boolean).forEach((el) => sectionOf(el).classList.add('mf-branch-only'));
  const addButtons = $$('[data-mf-add]');
  addButtons.forEach((b) => { b.dataset.label = b.firstChild.textContent.trim(); });
  function applyMode() {
    const on = personal();
    document.documentElement.classList.toggle('mf-personal', on);
    $$('[data-mf-mode-pick]').forEach((b) => { const sel = b.dataset.mfModePick === state.mode; b.classList.toggle('is-active', sel); b.setAttribute('aria-checked', sel); });
    addButtons.forEach((b) => { b.firstChild.textContent = (on ? 'Add to my order' : b.dataset.label) + ' '; });
    if (on) openBuilder();
    renderQuote();
  }
  modeEl && modeEl.addEventListener('click', (e) => {
    const b = e.target.closest('[data-mf-mode-pick]');
    if (!b || b.dataset.mfModePick === state.mode) return;
    state.mode = b.dataset.mfModePick; save(); applyMode();
  });

  const payBtn = $('[data-mf-pay-btn]');
  const payError = $('[data-mf-pay-error]');
  const payFail = (msg, focusEl) => {
    payError.hidden = false; payError.textContent = msg;
    if (focusEl) focusEl.focus();
  };
  const propsFor = (it) => {
    const line = lineById[it.lineId];
    const p = { Company: (modeEl && modeEl.dataset.company) || document.title, Color: it.color };
    if (it.productId === 'hats') {
      p.Style = line.name; p.Patch = it.patch || '';
      if (it.side && it.side !== 'none') p[sideLabel(it.side)] = it.sideText || '(details to follow)';
    } else {
      p.Decoration = line.decoration === 'embroidery' ? `Left-chest embroidery, ${hs.ink} thread` : hoodieDesignText();
    }
    return p;
  };
  payBtn && payBtn.addEventListener('click', async () => {
    payError.hidden = true;
    const lines = [];
    for (const it of state.items) {
      const q = qtyOf(it);
      if (!q) continue;
      const line = lineById[it.lineId];
      const props = propsFor(it);
      const sizes = productById[it.productId].sizes;
      const parts = sizes.length ? sizes.filter((z) => Number((it.sizes || {})[z])).map((z) => [z, Number(it.sizes[z])]) : [[null, q]];
      for (const [z, n] of parts) {
        const v = variantFor(it, z);
        if (!v) return payFail(`${line.short}${z ? ' in ' + z : ''} can't be ordered just for you yet. Remove it, or choose "My branch" for a quote.`);
        lines.push({ id: v.id, quantity: n, properties: props });
      }
    }
    if (!lines.length) return payFail('Add at least one item with a size or quantity first.', itemsEl.querySelector('input[type="number"]') || addLineSel);
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const post = (path, body) => fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(async (r) => { if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || j.message || 'Something went wrong.'); } return r.json(); });
    const label = $('[data-mf-pay-label]');
    payBtn.disabled = true; label.textContent = 'Opening checkout…';
    try {
      await post('cart/clear.js', {});
      await post('cart/add.js', { items: lines });
      await post('cart/update.js', { attributes: { Company: (modeEl && modeEl.dataset.company) || '', 'Order type': 'Personal' } });
      location.href = root + 'checkout';
    } catch (err) {
      payBtn.disabled = false; label.textContent = 'Checkout';
      payFail(`We couldn't start checkout: ${err.message} Try again, or email us your order.`);
    }
  });

  /* ---------- Quote builder ---------- */

  const quote = $('[data-mf-quote]');
  const itemsEl = $('[data-mf-items]');
  const addLineSel = $('[data-mf-add-line]');
  const sideLabel = (s) => (s && s !== 'none' && (hatCfg.sides || {})[s] ? hatCfg.sides[s].label : '');

  const hoodieDesignText = () => {
    const lay = activeLayout();
    const zones = zonesFor({ decoration: 'layouts' });
    const bits = [lay ? `Layout ${lay.id}: ${lay.name}` : '', `${hs.ink} print`];
    if (zones.city) bits.push(hs.city ? `City: ${hs.city.toUpperCase()}` : 'City: add in designer');
    if (zones['bicep-left'] || (zones['bicep-right'] && hs.bicep === 'store')) bits.push(hs.store ? `Store #${hs.store}` : 'Store #: add in designer');
    if (zones['bicep-right']) bits.push(hs.bicep === 'store' ? 'Right bicep: store #' : 'Right bicep: flag');
    if (zones.back) bits.push(hs.back === 'custom' ? `Back: CUSTOM DESIGN (${hs.backText.trim() || 'details to follow'})` : 'Back: logo');
    return bits.filter(Boolean).join(' · ');
  };

  function renderDesignCard() {
    const card = $('[data-mf-design-card]');
    if (!card || !hs.lineId) return;
    const hoodies = state.items.filter((it) => it.productId === 'hoodies');
    const printed = hoodies.some((it) => lineById[it.lineId].decoration !== 'embroidery');
    const emb = hoodies.some((it) => lineById[it.lineId].decoration === 'embroidery');
    card.hidden = !hoodies.length;
    const line = lineById[hs.lineId];
    const c = colorOf(line, hs.color);
    const ink = inks.find((i) => i.name === hs.ink) || {};
    const sw = $('[data-mf-design-swatch]', card);
    sw.style.setProperty('--sw', c.hex || '#888');
    sw.style.setProperty('--sw-img', c.pattern ? `url('${c.pattern}')` : 'none');
    sw.style.setProperty('--ink', ink.hex || '#fff');
    let text = printed ? hoodieDesignText() : '';
    if (emb) text += `${text ? ' · ' : ''}Carhartt: left-chest embroidery, ${hs.ink} thread`;
    $('[data-mf-design-summary]', card).textContent = text;
  }

  const itemHTML = (it, counts) => {
    const line = lineById[it.lineId];
    const d = productById[it.productId];
    const c = colorOf(line, it.color);
    const q = qtyOf(it);
    const unit = unitPrice(it, counts);
    const opts = (list, sel) => list.map((o) => `<option value="${esc(o.v)}"${o.v === sel ? ' selected' : ''}>${esc(o.t)}</option>`).join('');
    const lineSel = `<label>${esc(d.product.one.replace(/^./, (m) => m.toUpperCase()))}<select data-f="line">${opts(d.lines.map((l) => ({ v: l.id, t: l.short })), it.lineId)}</select></label>`;
    const colorSel = `<label>Color<select data-f="color">${opts(line.colors.map((cc) => ({ v: cc.name, t: cc.name })), it.color)}</select></label>`;
    const styleSel = line.styles.length ? `<label>Style<select data-f="style">${opts(line.styles.map((s) => ({ v: s.name, t: `${s.name} ($${s.price})` })), it.style)}</select></label>` : '';
    const isHat = it.productId === 'hats';
    const patchSel = isHat && patches.length ? `<label>Patch<select data-f="patch">${opts(patches.map((p) => ({ v: p.name, t: p.name })), it.patch)}</select></label>` : '';
    const sideSel = isHat ? `<label>Branch detail<select data-f="side">${opts([{ v: 'none', t: 'None' }].concat(Object.keys(hatCfg.sides || {}).map((k) => ({ v: k, t: `${hatCfg.sides[k].label} (+$${hatCfg.sidePrice})` }))), it.side || 'none')}</select></label>` : '';
    const sideText = isHat && it.side && it.side !== 'none' ? `<label class="mf-item__wide">Branch name or store #<input type="text" maxlength="20" value="${esc(it.sideText || '')}" data-f="sideText" placeholder="Fishersville or #121"></label>` : '';
    const chip = isHat
      ? `<span class="mf-item__chip mf-item__chip--photo" aria-hidden="true"><img src="${esc(c.thumb)}" alt="" width="128" height="90" loading="lazy"></span>`
      : `<span class="mf-item__chip" style="--sw:${esc(c.hex || '#888')};${c.pattern ? `--sw-img:url('${esc(c.pattern)}')` : ''}" aria-hidden="true"></span>`;
    const meta = [c.name, line.pricing === 'flat' ? 'flat price' : (c.camo && line.camoPrices.length ? 'camo pricing' : ''), isHat ? it.patch : '', isHat ? sideLabel(it.side) : ''].filter(Boolean).join(' · ');
    const blocked = personal() && personalUnit(it) == null;
    const qtyInputs = d.sizes.length
      ? `<fieldset class="mf-item__sizes"><legend class="visually-hidden">Quantity per size</legend>${d.sizes.map((z) => `<label class="mf-size"><span>${esc(z)}</span><input type="number" min="0" max="999" inputmode="numeric" placeholder="0" value="${Number((it.sizes || {})[z]) || ''}" data-size="${esc(z)}" aria-label="${esc(z)} quantity"></label>`).join('')}</fieldset>`
      : `<div class="mf-item__qty"><label class="mf-size"><span>Quantity</span><input type="number" min="0" max="999" inputmode="numeric" placeholder="0" value="${Number(it.qty) || ''}" data-qty aria-label="Quantity"></label><span class="mf-note">One size fits most</span></div>`;
    return `<li class="mf-item${isHat ? ' mf-item--hat' : ''}" data-item="${it.id}">
      <div class="mf-item__top">
        ${chip}
        <p class="mf-item__title">${esc(line.name)}<small>${esc(meta)}</small></p>
        <button type="button" class="mf-item__remove" data-remove aria-label="Remove ${esc(line.short)} ${esc(c.name || '')}">
          <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true"><path d="M5 5l10 10M15 5 5 15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
        </button>
      </div>
      <div class="mf-item__selects">${lineSel}${colorSel}${styleSel}${patchSel}${sideSel}${sideText}</div>
      ${qtyInputs}
      ${blocked ? `<p class="mf-error">${esc(line.short)} can't be ordered just for you yet. Remove it, or choose "My branch" for a quote.</p>` : ''}
      <p class="mf-item__foot"><span data-item-qty>${plural(q, d.product)} × ${money(unit)}</span><strong data-item-total>${money(q * unit)}</strong></p>
    </li>`;
  };

  const normalHTML = (n) => {
    const o = state.normals[n.id] || {};
    const f = normalFoot(n);
    const qtyInputs = n.sizes.length
      ? `<fieldset class="mf-item__sizes"><legend class="visually-hidden">Quantity per size</legend>${n.sizes.map((z) => `<label class="mf-size"><span>${esc(z)}</span><input type="number" min="0" max="999" inputmode="numeric" placeholder="0" value="${Number((o.sizes || {})[z]) || ''}" data-size="${esc(z)}" aria-label="${esc(z)} quantity"></label>`).join('')}</fieldset>`
      : `<div class="mf-item__qty"><label class="mf-size"><span>Quantity</span><input type="number" min="0" max="999" inputmode="numeric" placeholder="0" value="${Number(o.qty) || ''}" data-qty aria-label="Quantity"></label></div>`;
    return `<li class="mf-item mf-item--normal" data-item="n-${esc(n.id)}" data-normal="${esc(n.id)}">
      <div class="mf-item__top">
        <span class="mf-item__chip mf-item__chip--photo" aria-hidden="true">${n.img ? `<img src="${esc(n.img)}" alt="" width="128" height="90" loading="lazy">` : ''}</span>
        <p class="mf-item__title">${esc(n.name)}<small>Reorder${n.details ? ' · ' + esc(n.details) : ''}</small></p>
        <button type="button" class="mf-item__remove" data-remove aria-label="Remove ${esc(n.name)}">
          <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true"><path d="M5 5l10 10M15 5 5 15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
        </button>
      </div>
      ${qtyInputs}
      <p class="mf-item__foot"><span data-item-qty>${esc(f.qty)}</span><strong data-item-total>${f.total}</strong></p>
    </li>`;
  };

  function renderQuote() {
    if (!quote) { renderLadder(); renderCartChip(); return; }
    const { counts } = totals();
    if (itemsEl) {
      const focused = document.activeElement;
      const row = focused && focused.closest && focused.closest('[data-item]');
      const key = row ? [row.dataset.item, focused.dataset.size || focused.dataset.f || (focused.hasAttribute('data-qty') ? 'qty' : '')] : null;
      itemsEl.innerHTML = activeNormals().map(normalHTML).join('')
        + state.items.map((it) => itemHTML(it, counts)).join('');
      if (key) {
        const r = itemsEl.querySelector(`[data-item="${key[0]}"]`);
        const el = r && (r.querySelector(`[data-size="${key[1]}"]`) || r.querySelector(`[data-f="${key[1]}"]`) || (key[1] === 'qty' && r.querySelector('[data-qty]')));
        if (el) el.focus({ preventScroll: true });
      }
    }
    const empty = $('[data-mf-empty]'); if (empty) empty.hidden = state.items.length > 0 || activeNormals().length > 0;
    updateTotals();
    renderLadder();
  }

  function renderCartChip() {
    const { total, all } = totals();
    const c = $('[data-mf-cart-count]'); if (c) c.textContent = `${all} ${all === 1 ? 'item' : 'items'}`;
    const t = $('[data-mf-cart-total]'); if (t) t.textContent = money(total);
    const chip = $('[data-mf-cart-chip]'); if (chip) chip.classList.toggle('is-empty', !all);
  }

  function updateTotals() {
    const { counts, total, all, reorders } = totals();
    normals.forEach((n) => {
      const r = itemsEl && itemsEl.querySelector(`[data-normal="${n.id}"]`);
      if (!r) return;
      const f = normalFoot(n);
      $('[data-item-qty]', r).textContent = f.qty;
      $('[data-item-total]', r).textContent = f.total;
    });
    state.items.forEach((it) => {
      const r = itemsEl && itemsEl.querySelector(`[data-item="${it.id}"]`);
      if (!r) return;
      const q = qtyOf(it); const unit = unitPrice(it, counts);
      $('[data-item-qty]', r).textContent = `${plural(q, productById[it.productId].product)} × ${money(unit)}`;
      $('[data-item-total]', r).textContent = money(q * unit);
    });
    const tEl = $('[data-mf-total]'); if (tEl) tEl.textContent = money(total);
    const rows = $('[data-mf-sum-rows]');
    const hints = [];
    if (rows) {
      rows.innerHTML = (reorders ? `<div><dt>Reorders</dt><dd>${reorders} · your price</dd></div>` : '') + products.filter((d) => counts[d.product.id].all > 0).map((d) => {
        const pid = d.product.id;
        const pc = pricingCount(pid, counts);
        const ti = tierIndex(d.tiers, pc.count);
        if (personal()) return `<div><dt>${esc(d.product.label)}</dt><dd>${counts[pid].all}</dd></div>`;
        let tier = counts[pid].tier ? d.tiers[ti].label : 'flat price';
        if (pc.boosted) tier += ' (unlocked)';
        const nxt = d.tiers[ti + 1];
        if (counts[pid].tier && nxt && nxt.min - pc.count <= 10) hints.push(`Add ${nxt.min - pc.count} more ${nxt.min - pc.count === 1 ? d.product.one : d.product.many} and every one drops to the ${nxt.label} price.`);
        return `<div><dt>${esc(d.product.label)}</dt><dd>${counts[pid].all} · ${esc(tier)}</dd></div>`;
      }).join('') || '<div><dt>Items</dt><dd>0</dd></div>';
    }
    const hat = productById.hats;
    if (hat && hat.product.boostFrom && counts.hoodies && !personal()) {
      const need = hat.product.boostMin - counts.hoodies.tier;
      if (counts.hoodies.tier > 0 && need > 0 && need <= 10) hints.push(`Add ${need} more ${need === 1 ? 'hoodie' : 'hoodies'} to unlock ${hat.tiers[tierIndex(hat.tiers, hat.product.boostMin)].label} hat pricing.`);
    }
    if (activeNormals().some((n) => !n.price)) hints.push('Some reorders are priced on your quote, so they aren\'t in this total.');
    const hint = $('[data-mf-sum-hint]'); if (hint) hint.textContent = hints.join(' ');
    renderDesignCard();
    renderCartChip();
    writeBody(counts, total, all);
  }

  const writeBody = (counts, total, all) => {
    const body = $('[data-mf-body]');
    if (!body) return;
    const out = [];
    const re = activeNormals();
    if (re.length) {
      out.push('YOUR NORMALS (REORDER)');
      re.forEach((n, i) => {
        const o = state.normals[n.id] || {};
        const q = normalQty(n);
        const qtyText = n.sizes.length ? n.sizes.filter((z) => Number((o.sizes || {})[z])).map((z) => `${z} ${o.sizes[z]}`).join(', ') : `qty ${q}`;
        out.push(`${i + 1}. ${n.name}${n.details ? ' (' + n.details + ')' : ''} — ${qtyText} — ${n.price ? `${q} × ${money(n.price)} = ${money(q * n.price)}` : `${q} × price on quote`}`);
      });
      out.push('');
    }
    products.forEach((d) => {
      const pid = d.product.id;
      const items = state.items.filter((it) => it.productId === pid);
      if (!items.length) return;
      out.push(d.product.label.toUpperCase());
      if (pid === 'hoodies') {
        if (items.some((it) => lineById[it.lineId].decoration !== 'embroidery')) out.push('Design: ' + hoodieDesignText());
        if (items.some((it) => lineById[it.lineId].decoration === 'embroidery')) out.push(`Carhartt: left-chest embroidery, ${hs.ink} thread`);
      }
      items.forEach((it, i) => {
        const line = lineById[it.lineId];
        const q = qtyOf(it); const unit = unitPrice(it, counts);
        const qtyText = d.sizes.length ? (d.sizes.filter((z) => Number((it.sizes || {})[z])).map((z) => `${z} ${it.sizes[z]}`).join(', ') || 'no sizes entered') : `qty ${q}`;
        const extra = pid === 'hats' ? ` — Patch: ${it.patch || 'n/a'}${it.side && it.side !== 'none' ? ` — ${sideLabel(it.side)}: ${it.sideText || '(details to follow)'}` : ''}` : '';
        out.push(`${i + 1}. ${line.name}${it.style && line.styles.length ? ' (' + it.style + ')' : ''} — ${it.color}${extra} — ${qtyText} — ${q} × ${money(unit)} = ${money(q * unit)}`);
      });
      const pc = pricingCount(pid, counts);
      if (counts[pid].tier) out.push(`${d.product.label} counted toward tier pricing: ${counts[pid].tier}${pc.boosted ? ` (priced at ${d.tiers[tierIndex(d.tiers, pc.count)].label} via hoodie order)` : ` (${d.tiers[tierIndex(d.tiers, pc.count)].label})`}`);
      out.push('');
    });
    if (!state.items.length && !re.length) out.push('(nothing added)');
    out.push(`Total items: ${all}`);
    out.push(`Estimated total: ${money(total)} (estimate only)`);
    body.value = out.join('\n');
  };

  if (quote) {
    if (addLineSel) {
      addLineSel.innerHTML = products.map((d) => `<optgroup label="${esc(d.product.label)}">${d.lines.map((l) => `<option value="${l.id}">${esc(l.name)}</option>`).join('')}</optgroup>`).join('');
    }
    const addRow = $('[data-mf-add-row]');
    addRow && addRow.addEventListener('click', () => {
      const line = lineById[addLineSel.value] || products[0].lines[0];
      const isHat = line.productId === 'hats';
      const ds = isHat ? ts : hs;
      const color = line.id === ds.lineId ? ds.color : (line.colors[0] || {}).name;
      const it = isHat
        ? { id: uid(), productId: 'hats', lineId: line.id, color, patch: ts.patch, side: 'none', sideText: '', qty: 0 }
        : { id: uid(), productId: 'hoodies', lineId: line.id, color, style: line.styles[0] ? line.styles[0].name : '', sizes: {} };
      state.items.push(it); save(); renderQuote();
      const r = itemsEl.querySelector(`[data-item="${it.id}"]`);
      const first = r && $('input[type="number"]', r);
      first && first.focus();
    });
    itemsEl && itemsEl.addEventListener('input', (e) => {
      const r = e.target.closest('[data-item]'); if (!r) return;
      if (r.dataset.normal) {
        if (e.target.type !== 'number') return;
        setNormalQty(r.dataset.normal, e.target);
        save(); updateTotals(); renderNormalCards();
        return;
      }
      const it = state.items.find((x) => x.id === r.dataset.item); if (!it) return;
      const clamp = (v) => Math.max(0, Math.min(999, Math.round(Number(v) || 0)));
      if (e.target.dataset.size) { it.sizes = it.sizes || {}; it.sizes[e.target.dataset.size] = clamp(e.target.value); }
      else if (e.target.hasAttribute('data-qty')) it.qty = clamp(e.target.value);
      else if (e.target.dataset.f === 'sideText') it.sideText = e.target.value.slice(0, 20);
      else return;
      save(); updateTotals(); renderLadder();
    });
    itemsEl && itemsEl.addEventListener('change', (e) => {
      const r = e.target.closest('[data-item]'); if (!r) return;
      const it = state.items.find((x) => x.id === r.dataset.item); if (!it) return;
      const f = e.target.dataset.f;
      if (f === 'line') {
        it.lineId = e.target.value;
        const l = lineById[it.lineId];
        if (!l.colors.find((c) => c.name === it.color)) it.color = (l.colors[0] || {}).name;
        it.style = l.styles[0] ? l.styles[0].name : '';
      } else if (['color', 'style', 'patch', 'side'].includes(f)) it[f] = e.target.value;
      else return;
      save(); renderQuote();
    });
    itemsEl && itemsEl.addEventListener('click', (e) => {
      const rm = e.target.closest('[data-remove]'); if (!rm) return;
      const r = rm.closest('[data-item]');
      if (r.dataset.normal) delete state.normals[r.dataset.normal];
      else state.items = state.items.filter((x) => x.id !== r.dataset.item);
      save(); renderQuote(); renderNormalCards();
    });
    const edit = $('[data-mf-edit-hoodie]');
    edit && edit.addEventListener('click', (e) => { e.preventDefault(); setProduct('hoodies', { scroll: true }); });

    const form = $('#mf-quote-form');
    const formError = $('[data-mf-form-error]');
    form && form.addEventListener('submit', (e) => {
      const { all } = totals();
      if (!all) {
        e.preventDefault();
        if (formError) { formError.hidden = false; formError.textContent = 'Add at least one item with a quantity before sending. Use "Add item" or a designer above.'; }
        (itemsEl.querySelector('input[type="number"]') || addLineSel).focus();
        return;
      }
      if (formError) formError.hidden = true;
      updateTotals();
      const btn = $('[data-mf-submit]');
      if (btn) { btn.disabled = true; btn.firstChild.textContent = 'Sending… '; }
    });
    if ($('[data-mf-sent]')) {
      state.items = []; state.normals = {}; save();
      const done = $('[data-mf-sent]');
      done.scrollIntoView({ block: 'center' }); done.focus({ preventScroll: true });
    }
  }

  /* ---------- Boot ---------- */

  setView(stage ? stage.dataset.view : 'front');
  renderHoodie();
  renderHat();
  setProduct(state.product);
  renderNormalCards();
  applyMode();
})();
